// extracted by mini-css-extract-plugin
module.exports = {"container":"index__container__3tsMU","time-right":"index__time-right__2bB09","time-left":"index__time-left__3dCAL"};